/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

/**
 * Imports the Freighthub API.
 */
import { api } from '../api';

export default {
    /**
     * GET
     */
    getPlaces: function( params ){
        return api.get( '/carrier/gps/places', { params: params } );
    },

    /**
     * DELETE
     */
    deletePlace: function( placeId ){
        return api.delete( '/carrier/gps/places/' + placeId );
    },

    /**
     * POST
     */
    postPlace: function( { name, addressReadable, coordinates } ){
        return api.post( '/carrier/gps/places',
            {
                name: name,
                address_readable: addressReadable,
                coordinates: coordinates,
            }
        );
    },

    /**
     * PUT
     */
    putPlace: function( { id, name, addressReadable, coordinates} ){
        return api.put( '/carrier/gps/places/' + id,
            {
                name: name,
                address_readable: addressReadable,
                coordinates: coordinates,
            }
        );
    },
}